import { SegmentedControl, type SegmentOption } from "@/components/ui"

export type PaymentTab = "app" | "delivery"

type PaymentTabsProps = {
  activeTab: PaymentTab
  onTabChange: (tab: PaymentTab) => void
}

const TABS: readonly SegmentOption<PaymentTab>[] = [
  { value: "app", label: "Pagar pelo app" },
  { value: "delivery", label: "Pagar na entrega" },
]

export function PaymentTabs({ activeTab, onTabChange }: PaymentTabsProps) {
  return (
    <SegmentedControl
      options={TABS}
      value={activeTab}
      onValueChange={onTabChange}
      label="Forma de pagamento"
      idPrefix="payment"
    />
  )
}
